import React, { Component, createRef } from 'react'
import './App.css';
import './index.css';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Link,
  Redirect
} from "react-router-dom";
import 'semantic-ui-css/semantic.min.css';
import Temp from './components/Temp/Temp.jsx'
import Home from './pages/Index/index.jsx'
import About from './pages/About/about.jsx'
import Options from './pages/Options/options.jsx'
import Error404 from './pages/Error404/error404.jsx'

class App extends Component {
  state = {
    
  }

  render() {
    return (
      <div className="screen">
        <Router>
          {/* Use Switch to avoid 404 not rendering on all pages. */}
          <Switch>
            {/*All our Routes goes here!*/}
            <Route exact path="/" component={Home} />
            <Route exact path="/about" component={About} />
            <Route exact path="/options" component={Options} />
            <Route component={Error404} />
          </Switch>
        </Router>
        {/* <Temp /> */}
      </div>
      
    )
  }
}

export default App;
